import { defineStore } from 'pinia';
// eslint-disable-next-line import/no-extraneous-dependencies
import { notify } from 'notiwind';

import {
  Add,
  Get,
  Remove,
} from '@/api/basket';

// eslint-disable-next-line import/prefer-default-export
export const useBasketStore = defineStore('basket', {
  state: () => ({
    data: [],
    isLoading: false,
  }),
  actions: {
    async Add({
      data,
    }) {
      if (this.isLoading) return;
      try {
        const { data: { message } } = await Add({
          data,
        });
        notify(
          {
            variant: 'bg-green-700',
            group: 'foo',
            text: message,
          },
          5000,
        );
      } catch (error) {
        let message;
        if (error.response) {
          message = error.response.data.message;
        }
        message = message ?? 'An error occured while updating basket';
        notify(
          {
            variant: 'bg-red-700',
            group: 'foo',
            text: message,
          },
          5000,
        );
      }
    },
    async Load({ setLoading = true }) {
      if (setLoading) {
        this.isLoading = true;
      }
      try {
        const { data: { data } } = await Get();
        this.data = data;
      } catch (error) {
        let message;
        if (error.response) {
          message = error.response.data.message;
        }
        message = message ?? 'An error occured while loading basket';
        notify(
          {
            variant: 'bg-red-700',
            group: 'foo',
            text: message,
          },
          5000,
        );
      } finally {
        this.isLoading = false;
      }
    },
    async Remove(id) {
      try {
        const { data: { message } } = await Remove(id);
        notify(
          {
            variant: 'bg-green-700',
            group: 'foo',
            text: message,
          },
          5000,
        );
      } catch (error) {
        let message;
        if (error.response) {
          message = error.response.data.message;
        }
        message = message ?? 'An error occured while updating basket';
        notify(
          {
            variant: 'bg-red-700',
            group: 'foo',
            text: message,
          },
          5000,
        );
      }
    },
    SetData(data) {
      this.data = data;
    },
  },
  getters: {
    Data: (state) => state.data,
    TotalItems: (state) => (state.data ?? [])
      .reduce((accumulator, curValue) => accumulator + curValue.quantity, 0),
    IsLoading: (state) => state.isLoading,
    TotalCost: (state) => (state.data ?? [])
      // eslint-disable-next-line vue/max-len
      .reduce((accumulator, curValue) => accumulator + curValue.quantity * curValue.product.price, 0),
  },
});
